export const frontmatter = {
    "draft": true,
    "title": "MCPs",
    "description": "Model Context Protocol: conecta agentes de OnnIA con herramientas externas.",
    "sidebar_label": "MCPs",
    "sidebar_group": "guías",
    "sidebar_order": 6
}

export const toc = []